export const findLinks = (regex, text) => {
  const indices = [];
  for (let result = regex.exec(text); result !== null; result = regex.exec(text)) {
    indices.push(result.index);
  }
  return indices;
};
